import { render, staticRenderFns } from "./CourseSearchCardsMobile.vue?vue&type=template&id=4fc76da5&scoped=true&"
import script from "./CourseSearchCardsMobile.vue?vue&type=script&lang=ts&"
export * from "./CourseSearchCardsMobile.vue?vue&type=script&lang=ts&"
import style0 from "./CourseSearchCardsMobile.vue?vue&type=style&index=0&id=4fc76da5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc76da5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4fc76da5', component.options)
    } else {
      api.reload('4fc76da5', component.options)
    }
    module.hot.accept("./CourseSearchCardsMobile.vue?vue&type=template&id=4fc76da5&scoped=true&", function () {
      api.rerender('4fc76da5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/search/CourseSearchCardsMobile.vue"
export default component.exports